








import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class DetailedSlotGeneric extends Vue {
    @Prop() color!: string

}
